import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { IStudentGenerateFinalResults } from '@interfaces/IStudentResults';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-table-student-final-results',
  templateUrl: './table-student-final-results.component.html',
  styleUrls: ['./table-student-final-results.component.sass'],
})
export class TableStudentFinalResultsComponent implements OnInit, OnDestroy {
  @Input() data!: IStudentGenerateFinalResults;
  public showHomeworkResults$: Subject<boolean> = new Subject<boolean>();
  public showControlWorksResults$: Subject<boolean> = new Subject<boolean>();
  public showESDPResults$: Subject<boolean> = new Subject<boolean>();
  public showESDPReview$: Subject<boolean> = new Subject<boolean>();
  public displayedColumns: string[] = ['month', 'theme', 'result'];

  private homeworkResults$?: Subscription;
  private controlWorksResults$?: Subscription;

  ngOnInit(): void {
    this.homeworkResults$ = this.showHomeworkResults$.subscribe(show => {
      if (show) {
        this.displayedColumns.splice(2, 0, 'homeworks');
      } else {
        this.displayedColumns = this.displayedColumns.filter(
          col => col !== 'homeworks'
        );
      }
    });

    this.controlWorksResults$ = this.showControlWorksResults$.subscribe(
      show => {
        if (show) {
          this.displayedColumns.splice(2, 0, 'control-works');
        } else {
          this.displayedColumns = this.displayedColumns.filter(
            col => col !== 'control-works'
          );
        }
      }
    );
  }

  showHomeworkResults(e: MatSlideToggleChange): void {
    this.showHomeworkResults$.next(e.checked);
  }

  showControlWorksResults(e: MatSlideToggleChange): void {
    this.showControlWorksResults$.next(e.checked);
  }

  showESDPResults(e: MatSlideToggleChange): void {
    this.showESDPResults$.next(e.checked);
  }

  showESDPReview(e: MatSlideToggleChange): void {
    this.showESDPReview$.next(e.checked);
  }

  ngOnDestroy() {
    this.homeworkResults$?.unsubscribe();
    this.controlWorksResults$?.unsubscribe();
  }
}
